//API constants for email verification
export const emailVerificationConstants = {
  VERIFY_EMAIL: "VERIFY_EMAIL",
};

export const surveySystem = {
  SURVEY_SYSTEM: "HungerRush Feedback",
  INVALID_TOKEN: "Invalid Token.",
};

export const emailVerificationViewConstants = {
  INVITATION_EXPIRED: "Invitation Expired",
  SUPPORT_EMAIL: "hr360Marketing@hungerrush.com",
  INVITATION_EXPIRED_CONTACT: "Please contact with support team.",
  ACCOUNT_SETUP: "ACCOUNT SETUP",
  EMAIL_LABEL: "Email:",
  MOBILE_PHONE_LABEL: "Mobile Phone:",
  PASSWORD_LABEL: "Password:",
  CONFIRM_PASSWORD_LABEL: "Confirm Password:",
  PRIVACY_POLICY: "Privacy Policy",
  PRIVACY_AGREEMENT_PREFIX: "By joining, I agree to the",
  SETUP_PASSWORD_HINT:
    "Please generate a unique password and add your phone number to verify your account.",
  getInvitationExpiredBody: (systemName) =>
    `Your invitation to join ${systemName} has been expired.`,
  getWelcomeInviteLine: (brandOrSystem) =>
    `You're invited to join ${brandOrSystem}`,
};
